import React from 'react'
import { colors, s } from '../../style'
import BrightnessMediumIcon from '@material-ui/icons/BrightnessMedium'

const ThemeButton = ({ dispatch, theme, isScrollTop, menuOpen }) => {
  return (
    <div
      css={[
        sStyle(theme),
        menuOpen && sMenuScrolled(theme),
        isScrollTop === false && sMenuScrolled(theme),
      ]}
      onClick={() =>
        dispatch({
          type: 'TOGGLE_THEME',
        })
      }
      onKeyPress={() =>
        dispatch({
          type: 'TOGGLE_THEME',
        })
      }
      role="button"
      tabIndex={0}>
      <BrightnessMediumIcon />
    </div>
  )
}

const sStyle = (theme) => ({
  // [s.xs]: { display: 'none' }, //fix me later
  cursor: 'pointer',
  marginRight: '1rem',
  // padding: '0.875rem 1.5rem',
  width: 48,
  height: 48,
  [s.xs]: {
    marginRight: '0rem',
    // padding: '0.875rem 1rem',
  },
  transition:
    'color 0.25s ease-in, background-color 0.25s ease-in, padding 0.25s ease-in',
  fontSize: '1rem',
  borderRadius: '2rem',
  fontWeight: 700,

  lineHeight: '1em',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'transparent',
  color: colors[theme].menu.initial.activeLink.back,
  '&:hover': {
    [s.hover]: {
      backgroundColor: colors[theme].menu.initial.link.hover.back,

      color: colors[theme].menu.initial.link.text,
    },
  },
})

const sMenuScrolled = (theme) => ({
  // padding: '0.5rem 1rem',
  backgroundColor: 'transparent',
  color: colors[theme].logoReversed,
  '&:hover': {
    [s.hover]: {
      backgroundColor: colors[theme].menu.hovered.activeLink.back,
      color: colors[theme].menu.hovered.activeLink.text,
    },
  },
})

export default ThemeButton
